/**
 * ServiceCases section
 */
(function serviceCasesFrontend($, CountUp, window) {
    $(document).on('cms.ready', ready);

    // TODO: Does not work properly if added "fresh" on page

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    let slickSettings = {
        dots: true,
        dotsClass: "sectionServiceCases__progress",
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        focusOnSelect: true,
        swipeToSlide: true,
        arrows: true,
        fade: true,
    };

    /* Initial building of the ServiceCases */
    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionServiceCases', function(evt, entry, $elm) {
                saveTemplate($elm);

                loadCases(evt, entry, $elm);
            });
        } else {
            let $sections = $('.sectionServiceCases');

            $sections.each(function setupSection(i, elm) {
                saveTemplate($(elm));
            });

            // Set up intersect listener on section (delay GET until section is visible)
            $sections.on('cms.intersect', loadCases);
        }

        // Set up listeners
        $(document).on('sectionServiceCases.frontend.ready', frontendReady);
    }

    function saveTemplate($elm) {
        let $template = $elm.find('.sectionServiceCases__template').detach();

        if($template.prop('nodeName') === 'TEMPLATE') {
            let inner = $template.html();
            $template = $(inner);
        }

        // We want to refer to the template later, so save a reference on the section
        $elm.data('_template', $template);
    }

    function loadCases(event, entry, $section) {
        Contenda.log('loadCases', event, entry, $section);
        let ids = [],
            $template = $section.data('_template'),
            $servicesSlider = $('.sectionServiceCases__slider', $section);

        if(logged_in && !$section.data('document-listeners')) {
            addDocumentListeners($section);
            $section.data('document-listeners', true);
        }

        $servicesSlider.children('.sectionServiceCases__service-case').each(function(idx, elm) {
            ids.push($(elm).data('case-id'));
        });
        if(ids.length < 1) {
            $section.trigger('sectionServiceCases.frontend.ready');
            return;
        }

        // Get casepage data
        $.get(
            'api/casepage/idlist',
            { casepageIds: ids },
            function processCasePages(data) {
                // Go through the result casepages and update/create DOM elements
                $.each(data.rows, function processCasePage(i, serviceCase) {
                    let $child = $servicesSlider.find('[data-case-id='+serviceCase.id+']'),
                        $memberTemplate = $template.clone();
                    $memberTemplate.removeClass('sectionServiceCases__template');

                    for(let key in serviceCase) {
                        setValue($memberTemplate, key, serviceCase[key]);
                    }

                    // NTH: Better, more versatile handling of alt-text
                    let _images = $memberTemplate.find('img'); // img:not([alt]
                    if(_images.length > 0) {
                        let alt = serviceCase.title;
                        if(serviceCase.caseSliderOptions && serviceCase.caseSliderOptions.description) {
                            alt += ': ' + serviceCase.caseSliderOptions.description;
                        }
                        _images.each(function addAltText(i, img) {
                            $(img).attr('alt', alt);
                        })
                    }

                    // TODO: Consider removing picture tag if there is no image?
                    if(serviceCase.caseSliderOptions) {
                        if(serviceCase.caseSliderOptions.desktopImageUrl) {
                            // NTH: Better, more versatile handling of srcset
                            let _pictures = $memberTemplate.find('.service-case__image--desktop picture');
                            if (_pictures.length > 0) {
                                Contenda.setPictureSrcset(_pictures, serviceCase.caseSliderOptions.desktopImageUrl);
                            }
                        }
                        if(serviceCase.caseSliderOptions.mobileImageUrl) {
                            // NTH: Better, more versatile handling of srcset
                            let _pictures = $memberTemplate.find('.service-case__image--mobile picture');
                            if (_pictures.length > 0) {
                                Contenda.setPictureSrcset(_pictures, serviceCase.caseSliderOptions.mobileImageUrl);
                            }
                        }
                    }


                    removeEmptyStats($memberTemplate);

                    let linkDisabled = $child.data('link-disabled') === true || $child.data('link-disabled') === 'true';
                    applyLinkDisabled($memberTemplate, linkDisabled);

                    $memberTemplate.appendTo($child);
                });

                let $nonitems = $servicesSlider.find('[data-case-id="-1"]');
                if(logged_in) {
                    // Replace dummy items with placeholder content
                    $nonitems.each(function(idx, elm) {
                        let $memberTemplate = $template.clone();
                        $memberTemplate.removeClass('sectionServiceCases__template');

                        let serviceCase = placeholderCase();
                        for(let key in serviceCase) {
                            let value = serviceCase[key];
                            setValue($memberTemplate, key, value);
                        }

                        $memberTemplate.appendTo(elm);
                    });
                } else {
                    $nonitems.remove();
                }

                // Finally trigger frontend.ready to handle other updates (such as initializing slick)
                $section.trigger('sectionServiceCases.frontend.ready');
            }
        );
    }

    /**
     * Set the DOM value of an element based on key/value data
     * Finds DOM-elements with [data-field="<tt>key</tt>"] and sets the element's HTML to <tt>value</tt>
     *
     * Has special handling for the following keys:
     * - caseSliderOptions.caseImageUrl
     * - caseSliderOptions.logoImageUrl
     * - caseSliderOptions.desktopImageUrl
     * - caseSliderOptions.mobileImageUrl
     *
     * -- Assumes image tag and sets the <tt>src</tt> attribute to <tt>value</tt>
     * - reference
     * -- Assumes anchor tag and sets the <tt>href</tt> attribute to <tt>value</tt>
     *
     * @param $memberTemplate the template/dom element to set values on
     * @param key the key to update
     * @param value the value to set
     */
    function setValue($memberTemplate, key, value) {
        if($.isArray(value) || $.isPlainObject(value)) {
            for(let _key in value) {
                setValue($memberTemplate, key + '.' + _key, value[_key]);
            }
            return;
        }

        let elm = $memberTemplate.find('[data-field="' + key + '"]');

        switch (key) {
            case 'caseSliderOptions.caseImageUrl':
            case 'caseSliderOptions.logoImageUrl':
            case 'caseSliderOptions.desktopImageUrl':
            case 'caseSliderOptions.mobileImageUrl':
                elm.attr('src', value);
                break;
            case 'reference':
                elm.attr('href', value);
                break;
            default:
                elm.html(value);
                break;
        }
    }

    /**
     * Adds a placeholder item with temporary data
     * @param e triggering event (ignored)
     * @param idx index of where to add the element
     */
    function addPlaceholderItem(e, idx, $section) {
        let $servicesSlider = $('.sectionServiceCases__slider', $section),
            $template = $section.data('_template'),
            $child = $servicesSlider.children().eq(idx);
        $child.empty(); // Remove existing content

        let $memberTemplate = $template.clone();
        $memberTemplate.removeClass('sectionServiceCases__template');

        let serviceCase = placeholderCase();

        for(let key in serviceCase) {
            let value = serviceCase[key];
            setValue($memberTemplate, key, value);
        }

        $memberTemplate.appendTo($child);

        $section.trigger('sectionServiceCases.frontend.update');
    }

    function placeholderCase() {
        return {
            'name': 'Case',
            'caseSliderOptions': {
                'date': 'Sommer 2022',
                'description': 'Beskrivelse',
                'statnumber1': '+10%',
                'statdescription1': 'Stat 1',
                'statnumber2': '+5.36%',
                'statdescription2': 'Stat 2',
                'statnumber3': '+10%',
                'statdescription3': 'Stat 3',
                'desktopImageUrl': 'lib/images/lorem-placeholder-wide.webp#service-case-desktop',
                'mobileImageUrl': 'lib/images/lorem-placeholder-tall.webp#service-case-mobile'
            }
        }
    }

    /**
     * Handles updating slider and similar when the DOM is ready
     *
     * @param evt triggering event
     */
    function frontendReady(evt) {
        let $section = $(evt.target);

        slickSettings.prevArrow = $section.find('.sectionServiceCases__prev');
        slickSettings.nextArrow = $section.find('.sectionServiceCases__next');
        slickSettings.appendArrows = $section.find('.sectionServiceCases__navigation');
        slickSettings.appendDots = $section.find('.sectionServiceCases__navigation');

        let $slider = $section.find('.sectionServiceCases__slider');

        if(logged_in) {
            // Clone angular container and hide the original slider element (to keep bindings)
            let $parent = $slider.parent(),
                $clone = $slider.clone();
            $slider.hide();

            $clone.data('cloneOf', $slider);
            $clone.appendTo($parent);

            reinitializeSlick($clone);

            $section.on('sectionServiceCases.frontend.update', function() {
                $clone.remove(); // Destroy old clone
                $clone = $slider.clone(); // Create new clone
                $clone.appendTo($parent);

                $clone.data('cloneOf', $slider);

                reinitializeSlick($clone);
            });
        } else {
            reinitializeSlick($slider);

            // waitForSliderInView($slider, function updateSlider($slider) {
                let $nextSlide = $slider.find('.slick-current'),
                    $stats = $('.service-case__stat span', $nextSlide);

                // Reset stats to 0
                $stats.each(function resetStats(i, elm) {
                    let $elm = $(elm);
                    if($elm.data('countup')) {
                        $elm.data('countup').reset();
                    }
                });

                // Trigger start for stat-countup after a short delay
                setTimeout(function triggerChange() {
                    // Alternative: call either updateSlide or afterUpdateSlide
                    $stats.each(function updateStats(i, elm) {
                        let $elm = $(elm);
                        if($elm.data('countup')) {
                            $elm.data('countup').start();
                        }
                    });
                }, 500);
            // });
        }

    }

    function reinitializeSlick($slider) {
        // destroy slick and remove all depending classes
        $slider.hide();
        $slider.off('init', updateSlide);
        $slider.off('beforeChange', updateSlide);
        $slider.off('afterChange', afterUpdateSlide);

        // Ensure that appendDots element is also destroyed/removed
        if(slickSettings.appendDots && slickSettings.appendDots.children('.sectionServiceCases__progress').length) {
            slickSettings.appendDots.empty();
        }

        // In case we're actually reinitializing, we unslick first to ensure DOM structure
        if($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }

        // Set up new slider in a timeout to allow DOM changes to propagate
        setTimeout( function() {
            $slider.on('init', updateSlide);
            $slider.on('beforeChange', updateSlide);
            $slider.on('afterChange', afterUpdateSlide);
            $slider.show();
            $slider.slick(slickSettings);
        }, 100);
    }

    function updateSlide(event, slick, _currentSlide, _nextSlide) {
        Contenda.log('updateSlide', event, slick, _currentSlide, _nextSlide);
        if(typeof(_currentSlide) !== 'undefined' && _currentSlide === _nextSlide) {
            return;
        }
        let $slider = $(event.target)
            , $parent_section = $slider.parents('.sectionServiceCases')
            , $nextSlide = $slider.find('.slick-slide').eq(_nextSlide || 0)
        ;
        // Handle if the slider is a clone (when logged in as admin)
        if($slider.data('cloneOf')) {
            $nextSlide = $slider.data('cloneOf').find('.sectionServiceCases__service-case').eq(_nextSlide || 0)
        }

        // Update images
        // need to wait for the DOM to finish - otherwise it caused infinite loop
        let $images = $('.service-case__image img', $parent_section);
        setTimeout(function() {
            $images.each(function() {
                let $img = $(this);
                let src = $img.attr('src');

                if (src && src.indexOf('?opt=true') === -1) {
                    src += '?opt=true';
                    $img.attr('src', src);
                }
            });

            // if($nextSlide.data('bgImageUrl')) {
            //     let $background_image = $('<img src="' + basepath + $nextSlide.data('bgImageUrl') + '?opt=true" />');
            //
            //     // fade in the new image after load
            //     $background_image.hide().one('load', function() {
            //         $(this).fadeIn();
            //
            //         // and remove the old images
            //         $(this).siblings('img').fadeOut(function() {
            //             $(this).remove();
            //         });
            //     })
            //     $backgrounds.prepend($background_image);
            // } else {
            //     // Remove background by removing old images
            //     $('img', $backgrounds).fadeOut(function() {
            //        $(this).remove();
            //     });
            // }

            // Update stats
            let $stats = $('.service-case__stat span', $nextSlide);
            $stats.each(function updateStats(i, elm) {
                let $elm = $(elm),
                    text = $elm.text();

                if(text.trim().length < 1) {
                    // Skip empty stats
                    return;
                }

                if(!$elm.data('stat')) {
                    // Parse the text to create stat data

                    // Parse text to fit our requirements (we need a number)
                    // NG: We use , because we know input values use , as decimal separator
                    let number = text.replace(/[^\d,]/g,'').replace(',','.')

                    // Find amount of decimals
                    let decimals = 0;
                    if(number.indexOf('.') >= 0) {
                        decimals = number.length - (number.indexOf('.') + 1)
                    }

                    // Finally actually parse/covert to a number
                    number = parseFloat(number);

                    // First index of first digit in text to get our prefix
                    let prefix = '',
                        prefixIdx = text.search(/\d/);
                    if(prefixIdx >= 0) {
                        prefix = text.substring(0,prefixIdx);
                    }

                    // Find index of last digit in text to get our suffix
                    let reversed = text.split('').reverse().join(''),
                        suffixIdx = reversed.search(/\d/),
                        suffix = '';
                    if(suffixIdx >= 0) {
                        suffix = reversed.substring(0, suffixIdx);
                        // Reverse the suffix (if length > 1)
                        if(suffix.length > 1) {
                            suffix = suffix.split('').reverse().join('');
                        }
                    }

                    // Save on element for next time
                    $elm.data('stat', {
                        prefix: prefix,
                        number: number,
                        suffix: suffix,
                        decimals: decimals
                    });

                    let options = {
                        startVal: 0,
                        decimalPlaces: decimals,
                        duration: 2,
                        separator: '.',
                        decimal: ',',
                        suffix: suffix,
                        prefix: prefix
                    };
                    let countup = new CountUp(elm, number, options);
                    $elm.data('countup', countup);
                }

                if($elm.data('countup')) {
                    $elm.data('countup').reset();
                }
            });

            // Trigger countUp on stats element
            if(event.type == 'init') {
                setTimeout(function() {
                    afterUpdateSlide(event, slick, _nextSlide);
                }, 2000);
            }
        }, 100);
    }

    function afterUpdateSlide(event, slick, currentSlide) {
        let $slider = $(event.target)
            , $nextSlide = $slider.find('.slick-slide').eq(currentSlide || 0)
        ;
        // Handle if the slider is a clone (when logged in as admin)
        if ($slider.data('cloneOf')) {
            $nextSlide = $slider.data('cloneOf').find('.sectionServiceCases__service-case').eq(currentSlide || 0)
        }

        let $stats = $('.service-case__stat span', $nextSlide);
        $stats.each(function updateStats(i, elm) {
            let $elm = $(elm);
            if($elm.data('countup')) {
                $elm.data('countup').start();
            }
        });
    }

    function addDocumentListeners($section) {
        $(document).on('sectionServiceCases.addItem', function addItem(e, idx) {
            addPlaceholderItem(e, idx, $section);
        });

        /**
         * Handles the removal of an item by triggering frontend.update
         * @param e triggering event (ignored)
         * @param obj the object that has been removed
         */
        $(document).on('sectionServiceCases.removeItem', function removeItem(e, obj) {
            $section.trigger('sectionServiceCases.frontend.update');
        });

        /**
         * Updates an existing item with new data
         *
         * @param e triggering event
         * @param obj updated object data
         */
        $(document).on('sectionServiceCases.updateItem', function updateItem(e, obj) {
            let item = obj.item,
                idx = obj.idx;

            // In case there's no id, such as when a case reference is removed, update with a placeholder item instead
            if(!item.id) return addPlaceholderItem(e, idx, $section);

            let $servicesSlider = $('.sectionServiceCases__slider', $section),
                $template = $section.data('_template');

            // Remove old content
            let $child = $servicesSlider.children().eq(idx);
            $child.empty();

            // keep the slot's data attribute in sync for future reloads
            $child.attr('data-link-disabled', !!item.linkDisabled);

            // Fetch full data for the new casepage
            $.get(
                'api/casepage/' + item.id,
                function(serviceCase) {
                    let $memberTemplate = $template.clone();
                    $memberTemplate.removeClass('sectionServiceCases__template');

                    for(let key in serviceCase) {
                        setValue($memberTemplate, key, serviceCase[key]);
                    }
                    if(serviceCase.caseSliderOptions) {
                        // if (serviceCase.caseSliderOptions.desktopImageUrl) {
                        //     $memberTemplate.data('desktopImageUrl', serviceCase.caseSliderOptions.desktopImageUrl);
                        // }
                        // if (serviceCase.caseSliderOptions.mobileImageUrl) {
                        //     $memberTemplate.data('mobileImageUrl', serviceCase.caseSliderOptions.mobileImageUrl);
                        // }
                        if(serviceCase.caseSliderOptions.desktopImageUrl) {
                            // NTH: Better, more versatile handling of srcset
                            let _pictures = $memberTemplate.find('.service-case__image--desktop picture');
                            if (_pictures.length > 0) {
                                Contenda.setPictureSrcset(_pictures, serviceCase.caseSliderOptions.desktopImageUrl);
                            }
                        }
                        if(serviceCase.caseSliderOptions.mobileImageUrl) {
                            // NTH: Better, more versatile handling of srcset
                            let _pictures = $memberTemplate.find('.service-case__image--mobile picture');
                            if (_pictures.length > 0) {
                                Contenda.setPictureSrcset(_pictures, serviceCase.caseSliderOptions.mobileImageUrl);
                            }
                        }
                    }

                    removeEmptyStats($memberTemplate);

                    applyLinkDisabled($memberTemplate, !!item.linkDisabled);

                    // Add new content
                    $memberTemplate.appendTo($child);

                    // Trigger update
                    $section.trigger('sectionServiceCases.frontend.update');
                }
            );
        });
    }

    function applyLinkDisabled($memberTemplate, disabled) {
        if(disabled) {
            $memberTemplate.find('[data-field="reference"]').remove();
        }
    }

    function removeEmptyStats($memberTemplate) {
        let $stats = $memberTemplate.find('.service-case__stat');
        $stats.each(function removeEmptyStats(i, elm) {
            let $elm = $(elm),
                empty_stats = true;
            $elm.children().each(function checkEmptyStats(i, _child) {
                if(!$(_child).is(':empty') && empty_stats) {
                    empty_stats = false;
                }
            });
            if(empty_stats) {
                $elm.remove();
            }
        })
    }
})(jQuery, CountUp, window);